/**
 * Flashcard progress stored in localStorage.
 * Tracks which flashcards have been reviewed (swiped) and which are flagged for review.
 */

const REVIEWED_KEY = 'fc-reviewed';
const FLAGGED_KEY = 'fc-flagged';

function getSet(key: string): Set<string> {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function saveSet(key: string, set: Set<string>) {
  localStorage.setItem(key, JSON.stringify([...set]));
}

/** IDs of flashcards the user has swiped at least once (either direction). */
export function getReviewedFlashcardIds(): Set<string> {
  return getSet(REVIEWED_KEY);
}

/** Mark a flashcard as reviewed (seen/swiped). */
export function markFlashcardReviewed(id: string) {
  const set = getSet(REVIEWED_KEY);
  set.add(id);
  saveSet(REVIEWED_KEY, set);
}

/** IDs of flashcards marked for review (swiped left). */
export function getFlaggedFlashcardIds(): Set<string> {
  return getSet(FLAGGED_KEY);
}

/** Flag a flashcard for review (swiped left). */
export function flagFlashcard(id: string) {
  const set = getSet(FLAGGED_KEY);
  set.add(id);
  saveSet(FLAGGED_KEY, set);
}

/** Unflag a flashcard (swiped right / got it). */
export function unflagFlashcard(id: string) {
  const set = getSet(FLAGGED_KEY);
  set.delete(id);
  saveSet(FLAGGED_KEY, set);
}
